export const getAssignHref = (returnUrl: string, contentId: string) =>
  `/assignments/create?return_url=${returnUrl}&createdFrom=${contentId}&contentIds=${contentId}`;

export const getReadingSkillsLabels = (
  readingSkills: string[] | null,
): string[] => {
  if (!readingSkills?.length) return [];

  return [
    ...new Set(
      readingSkills.map((skill) => (skill.split("-")[1] as string) || skill),
    ),
  ];
};

export const getFormattedGradeLevelLabel = (gradeLevels: number[]): string => {
  if (!gradeLevels || gradeLevels.length === 0) return "";

  const gradeMap = {
    0: "Kindergarten ",
    1: "1st",
    2: "2nd",
    3: "3rd",
    4: "4th",
    5: "5th",
    6: "6th",
    7: "7th",
    8: "8th",
    9: "9th",
    10: "10th",
    11: "11th",
    12: "12th",
  };

  const sortedGrades = gradeLevels.sort((a, b) => a - b);

  const formatResult = (grade: keyof typeof gradeMap) =>
    gradeMap[grade] || `${grade}th`;
  const lowestGradeValue = sortedGrades[0];
  const highestGradeValue = sortedGrades[sortedGrades.length - 1];
  const lowestGradeIsDifferentFromHighestGrade =
    lowestGradeValue !== highestGradeValue;
  if (lowestGradeIsDifferentFromHighestGrade) {
    return `${formatResult(lowestGradeValue as keyof typeof gradeMap)}-${formatResult(highestGradeValue as keyof typeof gradeMap)}`;
  } else {
    return formatResult(lowestGradeValue as keyof typeof gradeMap);
  }
};

export const getFormattedLexileLevelLabel = (
  lexileLevels: number[],
): string => {
  if (!lexileLevels?.length || !lexileLevels[0]) return "";

  const sortedLexiles = lexileLevels.sort((a, b) => a - b);

  if (lexileLevels?.length === 1) return `${sortedLexiles[0] as number}L`;

  const lowestLexile = sortedLexiles[0]?.toString() as string;
  const highestLexile = sortedLexiles[
    sortedLexiles.length - 1
  ]?.toString() as string;

  return lowestLexile && highestLexile
    ? `${lowestLexile}L-${highestLexile}L`
    : "";
};

const readingSkillConsolidation = {
  "Main Idea": "Main Idea, Summarization, Key Details",
  Summarization: "Main Idea, Summarization, Key Details",
  "Key Details": "Main Idea, Summarization, Key Details",
};
type ReadingSkill = keyof typeof readingSkillConsolidation;

export const consolidateReadingSkills = (readingSkills: string[]) => {
  const skills = new Set<string>();

  readingSkills.forEach((skill) => {
    if ((skill as ReadingSkill) in readingSkillConsolidation) {
      skills.add(readingSkillConsolidation[skill as ReadingSkill]);
    } else {
      skills.add(skill);
    }
  });

  return [...skills];
};
